import React from "react";
import "./mainPage.css";

const MainPage = () => {
  return (
    <div className="main" id="main">
      <div className="main-title">
        <h1>
          Быстрые решения для <br />
          вашего <b>бизнеса!</b>
        </h1>
        <button>Подробнее</button>
      </div>
    </div>
  );
};

export default MainPage;
